var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinFIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8585 0H2.1428C0.959266 0 0 0.929933 0 2.07769V26.9213C0 28.0691 0.959588 29 2.1428 29H26.8585C28.042 29 29 28.0688 29 26.9213V2.07769C29 0.930256 28.042 0 26.8585 0ZM8.79193 24.2749H4.4103V11.1818H8.79193V24.2749ZM6.60144 9.3931H6.57212C5.10277 9.3931 4.15027 8.38809 4.15027 7.13013C4.15027 5.84672 5.1308 4.8691 6.62915 4.8691C8.12782 4.8691 9.04971 5.8464 9.07871 7.13013C9.07871 8.38841 8.12815 9.3931 6.60144 9.3931ZM24.5868 24.2749H20.2065V17.2698C20.2065 15.5092 19.5717 14.3083 17.9876 14.3083C16.7757 14.3083 16.0565 15.1187 15.7407 15.9007C15.6234 16.1804 15.5948 16.5709 15.5948 16.9615V24.2746H11.2151C11.2151 24.2746 11.2724 12.4094 11.2151 11.1814H15.5951V13.0378C16.1767 12.1458 17.2156 10.8734 19.542 10.8734C22.425 10.8734 24.5868 12.7436 24.5868 16.7672V24.2749ZM15.5667 13.0793C15.5745 13.0671 15.5848 13.0519 15.5951 13.0378V13.0793H15.5667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinFIcon);
export default __webpack_public_path__ + "static/media/linkdin-f-icon.ec92b287f14168c09fd112a5152c3e00.svg";
export { ForwardRef as ReactComponent };